import React, { useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { useFormik, Form, FormikProvider } from 'formik';
import { Box, Stack, TextField } from '@mui/material';
import { AddButton, CancelButton, SaveButton } from '../../../../components/mui/Buttons/Buttons';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createQrCode, getAllQrcodes } from '../../../../redux/features/qrCodesSlice';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';

const CreateQrCode = () => {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const { loading } = useSelector((state) => state.qrCodes);
  const [open, setOpen] = useState(false);

  const Schema = Yup.object().shape({
    name: Yup.string().required('name is required'),
    link: Yup.string().required('link is required'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      link: '',
      description: '',
    },
    validationSchema: Schema,
    onSubmit: (values, { resetForm }) => {
      dispatch(createQrCode(values)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            setOpen(false);
            dispatch(getAllQrcodes());
            resetForm();
          },
          onFailed: () => {
            console.log('Something went wrong');
          },
        });
      });
    },
  });
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={'Create New Qr Code'}
      closeButton={true}
      fullWidth
      maxWidth={'md'}
      popupButton={
        <AddButton size={'small'} action={() => setOpen(true)}>
          Create QR Code
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={'column'} spacing={2}>
                  <TextField
                    label="Qr Code Name"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.errors.name}
                  />
                  <TextField
                    label="Link"
                    name="link"
                    value={formik.values.link}
                    onChange={formik.handleChange}
                    error={formik.touched.link && Boolean(formik.errors.link)}
                    helperText={formik.errors.link}
                  />
                  <TextField
                    label="Description"
                    name="description"
                    value={formik.values.description}
                    multiline
                    rows={3}
                    onChange={formik.handleChange}
                    error={formik.touched.description && Boolean(formik.errors.description)}
                    helperText={formik.errors.description}
                  />
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <CancelButton size={'small'} action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SaveButton disabled={loading} size={'small'} type={'submit'}>
                      {loading ? 'Please Wait...!' : 'Save'}
                    </SaveButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CreateQrCode;
